<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="handleDelete"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="testData"
      :tableTitle="'Search results - Data Option Types'"
      :fields="[{ header: 'ID', prop: 'id' }, { header: 'First Name', prop: 'firstName' }, { header: 'Last Name', prop: 'lastName' }]"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  export default {
    name: 'DataOptionTypeSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    data () {
      return {
        loading: false,
        testData: [
          {
            id: 1,
            firstName: 'sdffsd',
            lastName: 'afdadf'
          }
        ]
      }
    },
    computed: {
    },
    methods: {
      handleEdit ({item, index}) {
        this.$router.push({ name: 'Admin - Edit/View Data Option Type', params: {id: item.id} })
      },
      handleDelete ({item, index}) {
        // @todo
        alert('I NEED IMPLEMENTING')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/DataOptionType/DataOptionTypeSearchResults.vue